export default __webpack_public_path__ + "static/art-innovation-1526c8cf62bc099d546480b98d0c92a8.png";